export class KennzahlenZurMethodik {
  geschlechterkoeffizient: number;
  standardfehler: number;
  freiheitsgrade: number;
  r2: number;
  hNull1KritischerWert: number;
  hNull1Teststatistik: number;
  hNull1Signifikanz?: number;
}
